import React from 'react'
import {
  Card,
  Grid,
  Typography as Text,
  Divider,
  Button,
} from '@material-ui/core'
import styles from '../WhatsNewStyles'
import { getImageFromFirebaseWithHook } from '../../../../apps/helpers'
const WhatsNewCard = ({ itemData }) => {
  const [image, setImage] = React.useState('')
  const classes = styles()
  React.useEffect(() => {
    getImageFromFirebaseWithHook(itemData.image, setImage)
  }, [])
  function handleOpenArticle(title) {
    const isLocalhost = window.location.hostname === 'localhost'
    const path = isLocalhost ? '/WhatsNewArticle/' : '/uxp/WhatsNewArticle/'
    const url = `${path}${title}`
    window.open(url, '_blank')
  }
  return (
    <Card variant="outlined" className={classes.itemCardContainer}>
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Text variant="h4">
            <b>{itemData.title}</b>
          </Text>
          <Divider />
        </Grid>
        <Grid item>
          <Text variant="body1" className={classes.itemDescription}>
            {itemData.description}
          </Text>
        </Grid>
        <Grid item className={classes.imageContainer}>
          <img className={classes.image} src={image} alt="" width="100%" />
          <Button
            onClick={() => handleOpenArticle(itemData.title)}
            className={classes.cardImageButton}
          >
            Learn more
          </Button>
        </Grid>
      </Grid>
    </Card>
  )
}

export default WhatsNewCard
